import styled from 'styled-components';

export const FilterCategoryMobileStyle = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
`;
